<template>
  <ClaimNewDeclarationVersionForm
    v-if="declarationUpdateRequest"
    :declaration="declaration"
    :declaration-update-request="declarationUpdateRequest"
  />
  <div v-else>
    <p v-if="currentClaim">Ce sinistre ne nécessite pas de nouvelle version de la déclaration.</p>
    <p v-else>Ce sinistre est introuvable.</p>
  </div>
</template>

<script>
import { ClaimNewDeclarationVersionForm } from "@estaly/ui";
import { mapActions, mapState } from "vuex";

export default {
  components: { ClaimNewDeclarationVersionForm },

  computed: {
    ...mapState("claims", ["currentClaim"]),

    claimFriendlyId() {
      return this.$route.params.id;
    },

    declaration() {
      return this.currentClaim?.declarations?.[0] || null;
    },

    declarationUpdateRequest() {
      return this.declaration?.declarationUpdateRequest;
    },
  },

  created() {
    this.fetch(this.claimFriendlyId);
  },

  methods: {
    ...mapActions("claims", ["fetch"]),
  },
};
</script>
